<template>
  <div class="container" id="kotsuResultPage">
    <!-- <h1>結果</h1> -->
    <h3>
      {{ rank }}
      <span class="rank-unit">レベル</span>
      <div class="d-flex justify-center mt-8">
        <div class="stamp" v-if="maxLabel">
          <span>記録<br />更新</span>
        </div>
        <div class="score">
          {{ score }}
        </div>
      </div>
    </h3>
    <div class="message mt-5 mb-5">{{ message }}<br /></div>

    <table>
      <tr>
        <th>タイム</th>
        <td>{{ Math.floor(timer / 10) }}.{{ Math.ceil(timer % 10) }} 秒</td>
      </tr>
      <tr>
        <th>正解数</th>
        <td>{{ correct }} / {{ counter }} 問</td>
      </tr>
      <tr>
        <th>自己最高</th>
        <td>{{ kotsuMax }}</td>
      </tr>
    </table>

    <h4>ヒント：</h4>
    <p class="hint">正答率と解答時間でボーナスが付きます</p>
    <div class="d-flex">
      <v-btn
        class="grey lighten-1 white--text flex-grow-0 mr-2"
        @click="goTop"
        large
      >
        <v-icon>mdi-home</v-icon>
      </v-btn>
      <v-btn class="red accent-3 white--text flex-grow-1" @click="retry" large>
        再挑戦<v-icon small class="pl-2">mdi-reload</v-icon>
      </v-btn>
      <v-btn
        class="light-blue lighten-2 white--text flex-grow-0 ml-2"
        :href="
          'http://twitter.com/share?url=https://tencount-f5bfb.web.app/&text=【点数表暗記ドリル】' +
            mode +
            '%20スコア%20' +
            this.score +
            '点%0a' +
            rank +
            'レベル！点数計算を練習中！%0a&hashtags=点数計算ドリル'
        "
        target="_blank"
        large
      >
        <v-icon>mdi-twitter</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "kotsuResult",
  data() {
    return {
      score: 0,
      kotsuMax: 0,
      counter: 1,
      correct: 0,
      timer: 0,
      rank: "ビギナー",
      message: "繰り返し解いて覚えよう！",
      mode: "面子符暗記モード",
      maxLabel: false,
    };
  },
  methods: {
    retry() {
      this.$router.push({
        name: "kotsu",
        query: {},
      });
    },
    goTop() {
      this.$router.push("/");
    },
  },
  created() {
    this.counter = this.$route.query.counter;
    this.correct = this.$route.query.correct;
    this.timer = this.$route.query.timer;

    // スコア計算
    let bonus = 200 - this.timer > 0 ? 200 - this.timer : 0;
    bonus = (bonus * this.correct) / this.counter;
    this.score = this.correct * 10 + Math.floor(bonus * 0.5);

    // result text
    if (this.score > 160) {
      this.rank = "鬼タップ";
      this.message = `早すぎィ!!`;
    } else if (this.score > 140) {
      this.rank = "麻雀の神";
      this.message = `他のパターンも
解いてみましょう!!`;
    } else if (this.score > 120) {
      this.rank = "雀荘オーナー";
      this.message = `他のパターンも
解いてみましょう!!`;
    } else if (this.score > 100) {
      this.rank = "雀荘店員";
      this.message = `かなりいい感じ。
もう一息!!`;
    } else if (this.score > 80) {
      this.rank = "常連客";
      this.message = `なかなかやりますね!!`;
    } else if (this.score > 60) {
      this.rank = "雀荘デビュー";
      this.message = `継続は力なり!!`;
    } else if (this.score > 40) {
      this.rank = "仲間うち";
      this.message = `九九のように
すらっと言えるようになろう!!`;
    } else {
      this.rank = "ビギナー";
      this.message = `繰り返し解いて
覚えよう!!`;
    }
  },
  mounted() {
    // 自己最高表示
    if (localStorage.kotsuMax) {
      this.kotsuMax = localStorage.kotsuMax;
    }
    // 自己最高更新
    if (this.kotsuMax < this.score) {
      this.kotsuMax = this.score;
      localStorage.kotsuMax = this.score;
      this.maxLabel = true;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/style.scss";

#kotsuResultPage {
  h2 {
    margin: 10px 0 10px;
    color: #333;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
  }
  h3 {
    font-size: 2rem;
    margin: 20px 0 0px;
    color: $theme-color;
  }
  h4 {
    text-align: left;
    font-size: 0.8rem;
    margin-bottom: 0.5rem;
  }
  .btn-twitter {
    margin-top: 40px;
  }
  .btn-top {
    color: #fff;
  }
  .rank-unit {
    font-size: 20px;
    color: #666;
  }
  .stamp {
    width: 60px;
    height: 60px;
    color: #f44336;
    border: 3px solid #f44336;
    box-shadow: 1px 1px #f44336;
    border-radius: 50%;
    overflow: hidden;
    font-size: 1.4rem;
    line-height: 1.1;
    padding-top: 3px;
    margin-top: -14px;
    margin-left: -2rem;
    margin-right: 6px;
    transform: rotate(-15deg);
  }
  .score {
    font-size: 4rem;
    // font-style: italic;
    font-weight: bold;
    text-shadow: 1px 3px 0px #d3d3d3, 0px 6px 0px #c3c3c3;
    font-family: Russo One;
  }
  .message {
    color: #333;
    font-size: 18px;
    line-height: 21px;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    tr {
      line-height: 1;
      border-bottom: solid 1px white;
      &:last-child {
        border-bottom: none;
      }
      th {
        position: relative;
        text-align: left;
        width: 30%;
        background-color: $theme-color;
        color: white;
        font-size: 0.9rem;
        text-align: center;
        padding: 10px 0;
      }
      td {
        padding-left: 1rem;
      }
    }
  }
  .hint {
    text-align: left;
    font-size: 0.8rem;
  }
  .sub-text {
    margin-top: 12px;
  }
}
</style>
